import { ErrorHandler, Injectable } from '@angular/core'
import { TositeUriService } from '@lemon/core-firebase/service/tosite/tosite-uri.service'
import { DateService } from '@lemon/core/service/date.service'
import { BehaviorSubject } from 'rxjs'
import { FirebaseLemonaid } from '../_angular/service/firebase-lemonaid.service'
import { KayttajaService } from '../_angular/service/kayttaja.service'
import { LemonTranslationService } from '../_jaettu-angular/service/lemon-translation.service'
import { MaksutFirestoreDataSource } from './maksut.firestore.datasource'

@Injectable()
export class MaksutSharedStateService {
  private _valittuTab = new BehaviorSubject<number>(0)
  valittuTabObservable = this._valittuTab.asObservable()

  constructor(
    private _errorHandler: ErrorHandler,
    private _kayttajaService: KayttajaService,
    private _lemonTranslationService: LemonTranslationService,
    private _firebaseLemonaid: FirebaseLemonaid,
    private _dateService: DateService,
    private _tositeUriService: TositeUriService,
  ) {}

  private _dataSource: MaksutFirestoreDataSource
  getDataSource(): MaksutFirestoreDataSource {
    if (!this._dataSource) {
      this._dataSource = new MaksutFirestoreDataSource(
        this._errorHandler,
        this._kayttajaService,
        this._lemonTranslationService,
        this._firebaseLemonaid,
        this._dateService,
        this._tositeUriService,
      )
    }
    return this._dataSource
  }

  tallennaValittuTab(value: number) {
    this._valittuTab.next(value)
  }
}
